import isEqual from 'react-fast-compare';
export const arrayAddOrUpdate = (arr, item, key) => {
    const itemKey = item[key];
    const itemIdx = arr.findIndex((i) => i[key] === itemKey);
    if (itemIdx === -1)
        return [...arr, item];
    const prevItem = arr[itemIdx];
    if (isEqual(prevItem, item))
        return arr;
    return [...arr.slice(0, itemIdx), item, ...arr.slice(itemIdx + 1)];
};
//# sourceMappingURL=arrayAddOrUpdate.js.map